module.exports = __webpack_public_path__ + "img/i_dobrev.ee802f25.jpg";